import React, { useEffect, useState, useRef } from "react"; // Import useRef
import "../styles/Founder.css";
import hari from "../assets/images/harshith.png";
import bannerDesktopAbout from "../assets/images/banner4_deskto.webp";
import bannerMobileAbout from "../assets/images/banner4_phon.webp";
import AboutUsSection from "./about-us-section";

const TimelineItem = ({ year, title, description, quote }) => {
  return (
    <div className="timeline-item">
      <div className="timeline-dot"></div>
      <div className="timeline-date">{year}</div>
      <div className="timeline-content">
        <h3 className="timeline-title">{title}</h3>
        <p className="timeline-desc">{description}</p>
        <div className="timeline-quote">{quote}</div>
      </div>
    </div>
  );
};

const FounderSection = () => {

  // Create refs for the elements you want to animate on scroll
  const founderImageWrapperRef = useRef(null);
  const founderCtaRef = useRef(null);

  useEffect(() => {
    // Initialize particles.js
    // This effect runs once after the initial render
    if (window.particlesJS) {
      window.particlesJS("particles-js", {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: "#f3b200",
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#000000",
            },
            polygon: {
              nb_sides: 5,
            },
          },
          opacity: {
            value: 0.3,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 5,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#FF9800",
            opacity: 0.2,
            width: 1,
          },
          move: {
            enable: true,
            speed: 2,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "grab",
            },
            onclick: {
              enable: true,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      });
    }
  }, []);

  // Effect for scroll-based animations (Timeline, Founder Image, CTA)
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      // const windowTop = window.scrollY;

      // Timeline items animation
      document.querySelectorAll(".timeline-item").forEach((item) => {
        // No ref needed here as querySelectorAll returns a NodeList which might contain
        // elements not yet referenced by individual refs, and direct DOM access is okay here
        // as long as the elements are expected to be in the DOM.
        const elementTop = item.getBoundingClientRect().top; // Relative to viewport
        if (elementTop < windowHeight - 100) { // Check if it's within 100px from bottom of viewport
          item.classList.add("animated");
        }
      });

      // Founder image wrapper animation
      const founderImage = founderImageWrapperRef.current; // Access element via ref
      if (founderImage) { // Check if the element exists
        const founderImageTop = founderImage.getBoundingClientRect().top; // Relative to viewport
        if (founderImageTop < windowHeight - 100) {
          founderImage.classList.add("animated");
        }
      }

      // Founder CTA animation
      const founderCta = founderCtaRef.current; // Access element via ref
      if (founderCta) { // Check if the element exists
        const founderCtaTop = founderCta.getBoundingClientRect().top; // Relative to viewport
        if (founderCtaTop < windowHeight - 100) {
          founderCta.classList.add("animated");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Call once on load to check initial visibility
    return () => window.removeEventListener("scroll", handleScroll);
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <>
      <section className="founder-section">
        <div className="founder-particles" id="particles-js"></div>
        <div className="aboutImg">
          <picture>
            <source media="(max-width: 768px)" srcSet={bannerMobileAbout} />
            <img
              src={bannerDesktopAbout}
              alt="About Us Banner"
              className="full-image animated" // Consider if this 'animated' should be dynamic based on scroll
              data-animation-in="zoomInImage"
            />
          </picture>
        </div>
        <div>
          <div className="section-title">
            <h2 className="animate__animated animate__fadeIn">
              From Engineer to Entrepreneur
            </h2>
            <p className="animate__animated animate__fadeIn animate__delay-1s">
              The inspiring journey of our founder who transformed his passion for
              traditional food products into a thriving business that celebrates
              authenticity and quality.
            </p>
          </div>
          <div className="founder-content">
            <div className="row">
              <div className="col-lg-6">
                <div className="founder-timeline">
                  <p className="year2014">2014-2018</p>
                  <TimelineItem
                    title="Foundations of a Dream"
                    description="Started engineering at MVJ College and discovered a passion for entrepreneurship. After graduation, worked at a Aerospace MNC in Bangalore, gaining structure, discipline, and exposure to quality systems."
                    quote='"College lit the spark. Industry gave it direction."'
                  />

                  <TimelineItem
                    year="2020"
                    title="The Turning Point"
                    description="Left a high-paying job during the COVID-19 pandemic. Returned home, reflected on lifestyle and food choices, and began researching natural wellness and cold-pressed oils."
                    quote='"That year redefined my purpose — I had to bring change."'
                  />

                  <TimelineItem
                    year="2021"
                    title="Vision to Venture"
                    description="Launched Haronics Consumer Products LLP. Introduced Baked Coconut Chips and began research into traditional food techniques, small-batch clean production, and sustainable sourcing."
                    quote='"From my coconut farm to your shelf — tradition meets innovation."'
                  />

                  <TimelineItem
                    year="2022"
                    title="Icon of Indian Business Award"
                    description="Honored with the Icon of Indian Business Award for Young Age Entrepreneurship and the Karnataka Business Award for Best Coconut Chips Manufacturer Category"
                     quote="Awarded for Young Entrepreneurship & Best Coconut Chips Manufacturer"
                  />
                  <TimelineItem
                    year="2025"
                    title="Future Milestone"
                    description="Haronics Cold Pressed Oils is set to expand its footprint across India by establishing new production units and introducing a wider range of products And  Presence in Digital Platform across India."
                    quote='"Our mission: Purity. Honesty. Heritage."'
                  />  
                </div>

              </div>

              <div className="col-lg-6">
                <div className="founder-image-container">
                  <div className="founder-image-wrapper" ref={founderImageWrapperRef}>
                    <img src={hari} alt="Founder" className="founder-image" />
                    <div className="founder-image-bg"></div>
                    <div className="founder-badge">
                      <div className="founder-badge-icon">
                        <i className="fas fa-award"></i>
                      </div>
                      <div className="founder-badge-text">Entrepreneur of the Year 2022</div>
                    </div>
                    <div className="founder-floating-icons">
                      <i className="fas fa-cog floating-icon" style={{ top: "10%", left: "10%" }}></i>
                      <i className="fas fa-flask floating-icon" style={{ top: "20%", right: "15%" }}></i>
                      <i className="fas fa-leaf floating-icon" style={{ bottom: "15%", left: "20%" }}></i>
                      <i className="fas fa-seedling floating-icon" style={{ bottom: "30%", right: "10%" }}></i>
                      <i className="fas fa-lightbulb floating-icon" style={{ top: "40%", left: "30%" }}></i>
                    </div>
                  </div>
                  <div>
                    {/* <img src={abt} alt="img" /> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="founder-cta" ref={founderCtaRef}>
              <h3 className="cta-title">Join Our Journey</h3>
              <p className="cta-desc">
                We continue to innovate while honoring tradition, bringing the authentic taste of nature to your table.
                Experience the difference that passion, engineering precision, and respect for tradition can make.
              </p>
              <a href="#fullstory" className="btn btn-story">
                Read Full Story
              </a>
            </div>
          </div>

        </div>

      </section>
      <AboutUsSection />

    </>

  );
};

export default FounderSection;